export default __webpack_public_path__ + "static/media/Henrique Rímoli.33d29fba.png";